<script>
import VueSlickCarousel from 'vue-slick-carousel';
import ChevronLeftIcon from '~/static/images/chevron-left.svg';
import ChevronRightIcon from '~/static/images/chevron-right.svg';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import Slide from '~/components/pages/components/Slide.vue';

export default {
    components: {
        VueSlickCarousel,
        ChevronLeftIcon,
        ChevronRightIcon,
        Slide,
    },
    props: {
        component: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            userInteracted: false,
            activeSlideIndex: 0,
        };
    },
    computed: {
        isMobile() {
            return this.$store.getters['settings/isMobile'];
        },
        showControls() {
            return this.component.slides.length > 1
                && this.component.show_controls;
        },
        controlClasses() {
            const classes = [];

            if (this.component.slides.length > this.component.slides_to_show) {
                classes.push('md:flex');
            } else {
                classes.push('md:hidden');
            }

            if (this.component.slides.length > this.component.slides_to_show_mobile) {
                classes.push('flex');
            } else {
                classes.push('hidden');
            }

            return classes;
        },
        shouldAutoplay() {
            return (this.component.autoplay || false) && !this.userInteracted;
        },
    },
    methods: {
        goToPrev() {
            this.userInteracted = true;
            this.$refs.carousel.prev();
        },
        goToNext() {
            this.userInteracted = true;
            this.$refs.carousel.next();
        },
        handleSwipe() {
            this.userInteracted = true;
        },
        handleAfterChange(slideIndex) {
            this.activeSlideIndex = slideIndex;
        },
    },
};
</script>

<template>
    <div :class="`style-${component.style} relative`">
        <VueSlickCarousel
            v-if="component.slides"
            ref="carousel"
            :arrows="false"
            :slides-to-show="isMobile && component.slides_to_show_mobile ? component.slides_to_show_mobile : component.slides_to_show"
            :slides-to-scroll="isMobile && component.slides_to_scroll_mobile ? component.slides_to_scroll_mobile : component.slides_to_scroll"
            :swipe-to-slide="true"
            :infinite="true"
            :class="{ 'slick-multi': component.components_per_slide > 1, 'mt-alternate': component.alternate_position }"
            :autoplay="shouldAutoplay"
            :autoplay-speed="(component.autoplay_speed || 3) * 1000"
            lazy-load="ondemand"
            @swipe="handleSwipe"
            @afterChange="handleAfterChange"
        >
            <Slide
                v-for="(slide, index) in component.slides"
                :key="`slide-${slide.id}`"
                :slide="slide"
                :is-active="index === activeSlideIndex"
            />
        </VueSlickCarousel>
        <div
            v-if="showControls"
            class="slide-navigation-button slide-navigation-button--left"
            :class="controlClasses"
            @click="goToPrev"
        >
            <ChevronLeftIcon class="slide-navigation-button__icon" />
        </div>
        <div
            v-if="showControls"
            class="slide-navigation-button slide-navigation-button--right"
            :class="controlClasses"
            @click="goToNext"
        >
            <ChevronRightIcon class="slide-navigation-button__icon" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.slide-navigation-button {
    @apply absolute text-white cursor-pointer transition-fast transition-property-color items-center;
    @apply top-0 bottom-0;

    &--left {
        @apply left-4;
    }

    &--right {
        @apply right-4;
    }

    &__icon {
        @apply w-8 md:w-12 h-8 md:h-12;
    }

    &:hover {
        @apply text-2025-blue;
    }
}
</style>
